<template>
  <div
    class="layout-default"
    :class="{ 'layout-default--focus-page': focusPage }"
  >
    <CookiePopup data-gtm-container="cookie-popup" />
    <HeaderContact website-type="mainSite" />

    <SHeaderBase v-if="focusPage" disable-logo-link />
    <SHeaderMain v-else data-gtm-container="header" />

    <main class="layout-default__main" data-gtm-container="main">
      <PToast position="bottom-right" />
      <slot />
    </main>
    <footer v-if="focusPage" data-gtm-container="footer">
      <SFooterBottom :link-component="NuxtLink" />
    </footer>
    <SFooterMain
      v-else
      data-gtm-container="footer"
      :link-component="NuxtLink"
      website-type="mainSite"
    />
    <UnsupportedBrowser :locale="getEnv().config.localeCode" />
  </div>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";

import {
  HeaderContact,
  PToast,
  SFooterBottom,
  SFooterMain,
  SHeaderBase,
  SHeaderMain,
} from "@solvari/components";
import { getEnv } from "@solvari/utils";

import CookiePopup from "~/widgets/CookiePopup.vue";
import UnsupportedBrowser from "~/widgets/UnsupportedBrowser.vue";

// The only layout: a layout switch remounts the page in the slot, this prop re-renders in place
defineProps<{ focusPage?: boolean }>();
</script>

<style lang="postcss">
.layout-default {
  @apply flex min-h-screen flex-col;

  &__main {
    @apply flex flex-grow flex-col;
  }
}
</style>
